import React from 'react'
import { observer } from 'mobx-react-lite'
import { MDBBtn, MDBCol, MDBRow } from 'mdb-react-ui-kit'
import { addWeeks, endOfWeek, format, getWeek, startOfWeek, subWeeks } from 'date-fns'

const WeekSelector = observer(({ dateFrom, dateTo, onWeekChange, disabled }) => {
  const handlePrevious = () => {
    const newFrom = startOfWeek(subWeeks(dateFrom, 1), { weekStartsOn: 1 })
    const newTo = endOfWeek(subWeeks(dateFrom, 1), { weekStartsOn: 1 })
    onWeekChange(newFrom, newTo)
  }

  const handleCurrent = () => {
    const now = new Date()
    const newFrom = startOfWeek(now, { weekStartsOn: 1 })
    const newTo = endOfWeek(now, { weekStartsOn: 1 })
    onWeekChange(newFrom, newTo)
  }

  const handleNext = () => {
    const newFrom = startOfWeek(addWeeks(dateFrom, 1), { weekStartsOn: 1 })
    const newTo = endOfWeek(addWeeks(dateFrom, 1), { weekStartsOn: 1 })
    onWeekChange(newFrom, newTo)
  }

  const prevFrom = startOfWeek(subWeeks(dateFrom, 1), { weekStartsOn: 1 })
  const prevTo = endOfWeek(subWeeks(dateFrom, 1), { weekStartsOn: 1 })

  return (
    <div className='week-selector'>
      <MDBRow>
        <MDBCol size='12' md='6'>
          <div className='factor-explain'>
            <h3 className='text-center'>Bar-Breakers Week #{getWeek(prevFrom)}</h3>
            <p className='text-center'>Agents who broke the bar during the previous business week.</p>
            <h4 className='text-center'>
              {format(prevFrom, 'MMM dd, yyyy')} - {format(prevTo, 'MMM dd, yyyy')}
            </h4>
          </div>
        </MDBCol>
        <MDBCol size='12' md='6'>
          <div className='factor-explain'>
            <h3 className='text-center'>NSM / Contest Week #{getWeek(dateFrom)}</h3>
            <p className='text-center'>Wheel of Love runs on this week's National Sales Meeting.</p>
            <h4 className='text-center'>
              {format(dateFrom, 'MMM dd, yyyy')} - {format(dateTo, 'MMM dd, yyyy')}
            </h4>
          </div>
        </MDBCol>
      </MDBRow>
      {!disabled && (
        <MDBRow className='mt-2 dates-selector'>
          <MDBCol className='text-center'>
            <h5>Previous</h5>
            <MDBBtn type='button' tag='a' color='flat' className='text-primary' onClick={handlePrevious}>
              Week
            </MDBBtn>
          </MDBCol>
          <MDBCol className='text-center'>
            <h5>Current</h5>
            <MDBBtn type='button' tag='a' color='flat' className='text-primary' onClick={handleCurrent}>
              Week
            </MDBBtn>
          </MDBCol>
          <MDBCol className='text-center'>
            <h5>Next</h5>
            <MDBBtn type='button' tag='a' color='flat' className='text-primary' onClick={handleNext}>
              Week
            </MDBBtn>
          </MDBCol>
        </MDBRow>
      )}
    </div>
  )
})

export default WeekSelector
